// extracted by mini-css-extract-plugin
module.exports = {"footer":"CompleteModal_footer__3ANv9"};